import withSelectedPatientClaims from '../../hoc/withSelectedPatientClaims';
import RxPrescriberGroupList from './RxPrescriberGroupList';

export default withSelectedPatientClaims(RxPrescriberGroupList);
